import React from 'react'
import { Button, Col, Table } from 'antd'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const StyledTable = styled(Table)`
  margin: 8px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`
export const StyledStrong = styled.strong`
  font-size: 16px;
  margin: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 80%, #1890ff 99%);
`

function Tracking(props) {
  const { title, data, id, trackingNumber } = props
  return (
    <>
      <StyledTable
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
            render: (value) => <strong>{value}</strong>,
          },
          {
            title: 'Value',
            dataIndex: 'value',
            // render: value => {value}</strong>,
          },
        ]}
        dataSource={data}
        {...{
          bordered: false,
          loading: false,
          pagination: false,
          size: 'small',
          title: title && (() => <StyledStrong>{title}</StyledStrong>),
          showHeader: false,
          footer: false,
          scroll: undefined,
          hasData: true,
        }}
      />
      <Col>
        <Link to={`/tracking/${id}/update`}>
          <Button type="dashed">Open Tracking Module</Button>
        </Link>
        <a style={{ marginLeft: 5 }} href={`http://tracking.mondiale.com/order/${trackingNumber}`} target="_blank">
          <Button>External Tracking Page</Button>
        </a>
      </Col>
    </>
  )
}

Tracking.defaultProps = {
  data: [],
}

export default Tracking
